import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Tabs, Spin } from 'antd';
import PageHeader from './PageHeader';
import { TM_IAD_ALERTS_DETAILS, FRAUD_IAD_ALERTS_DETAILS } from './constant';
import style from './index.scss';
import { PageContentTabs, TabContainer } from './styled';
import CustomerDetailsTab from './CustomerDetailsTab';
import AlertDetailsTab from './AlertDetailsTab';
import TransactionDetailsTab from './TransactionDetailsTab';
import ScoreExplainability from '../../tmCommon/ScoreExplainability';
import ProfileAndPeerComparison from '../../tmCommon/components/ProfileAndPeerComparison';
import { TM_FRAUD_SOURCE_STRINGS } from '../../../util/GlobalConstant';

const { TabPane } = Tabs;

const DetailedAlertInvestigation = ({
  apiActions,
  settings,
  match,
  isLoading,
  alertDetails,
  alertId = null,
  /* CM Integration */
  alertMetaSuffix,
  alertMetaPrefix,
  isEmbedded = false,
  sourceId
  /* --------------*/
}) => {
  const { getAMLSCommonGlobalSettingsPageInfo } = apiActions;

  useEffect(() => {
    if (sourceId) {
      // tm 6
      // fraud 21

      if (
        sourceId === TM_FRAUD_SOURCE_STRINGS.FRAUDIAD ||
        sourceId === TM_FRAUD_SOURCE_STRINGS.RTFRAUDIAD ||
        sourceId === TM_FRAUD_SOURCE_STRINGS.RTFRAUDIAD_BATCH
      ) {
        getAMLSCommonGlobalSettingsPageInfo({
          pageId: FRAUD_IAD_ALERTS_DETAILS
        });
      }

      if (
        sourceId === TM_FRAUD_SOURCE_STRINGS.TMIAD ||
        sourceId === TM_FRAUD_SOURCE_STRINGS.TMIAD_RUN_INSTANCE
      ) {
        getAMLSCommonGlobalSettingsPageInfo({ pageId: TM_IAD_ALERTS_DETAILS });
      }
    } else {
      getAMLSCommonGlobalSettingsPageInfo({ pageId: TM_IAD_ALERTS_DETAILS });
    }
  }, [sourceId]);

  const componentsTabPane = (
    <Tabs defaultActiveKey="1">
      <TabPane tab="Customer Details" key="1">
        {settings && (
          <CustomerDetailsTab
            settings={settings}
            alertId={alertId || match.params.alertId}
            sourceId={sourceId}
          />
        )}
      </TabPane>
      <TabPane tab="Transaction Details" key="2">
        {settings && (
          <TransactionDetailsTab
            settings={settings}
            alertId={alertId || match.params.alertId}
            sourceId={sourceId}
          />
        )}
      </TabPane>
      <TabPane tab="Alert Details" key="3">
        {settings && (
          <AlertDetailsTab
            settings={settings}
            alertId={alertId || match.params.alertId}
          />
        )}
      </TabPane>
      <TabPane tab="Score Explainability" key="4">
        <ScoreExplainability alertId={alertId || match?.params?.alertId} />
      </TabPane>
      <TabPane tab="Additional Information" key="5">
        <div className={style.tabContent}>
          <div className={style.secondaryTab}>
            <Tabs defaultActiveKey="2">
              {/* <TabPane tab="In/Out Transactions" key="1">
                 In/Out Transactions
               </TabPane> //TODO - Updated and Developed in future*/}
              <TabPane tab="Profile and peer comparison" key="2">
                <ProfileAndPeerComparison
                  alertId={alertId || match.params.alertId}
                  alertDetails={alertDetails}
                />
              </TabPane>
            </Tabs>
          </div>
        </div>
      </TabPane>
    </Tabs>
  );

  return (
    <Spin size="large" spinning={isLoading}>
      <div className={style.root}>
        <div className={isEmbedded && style.pageContent}>
          <PageHeader
            sourceId={sourceId}
            settings={settings}
            alertId={alertId || match.params.alertId}
            {...{ alertMetaSuffix, alertMetaPrefix, isEmbedded }}
          />

          <TabContainer>
            {
              /* CM Integration */
              isEmbedded ? (
                <PageContentTabs> {componentsTabPane} </PageContentTabs>
              ) : (
                /* TRM Integration */
                componentsTabPane
              )
            }
          </TabContainer>
        </div>
      </div>
    </Spin>
  );
};

DetailedAlertInvestigation.propTypes = {
  apiActions: PropTypes.object.isRequired,
  settings: PropTypes.object,
  match: PropTypes.object,
  isLoading: PropTypes.bool,
  alertMetaSuffix: PropTypes.element,
  alertMetaPrefix: PropTypes.element,
  isEmbedded: PropTypes.bool
};

export default DetailedAlertInvestigation;
